import './PageFrame.css';

// Home is the reference frame for all route shells and their navigation.
export const pageFrameStyle = {
  boxSizing: 'border-box',
  width: '100%',
  maxWidth: 'var(--pp-frame-max)',
  marginInline: 'auto',
  paddingInline: 'var(--pp-page-gutter)',
};
